module.exports = __webpack_public_path__ + "img/infostock_fake_news_check_left.695ab36.png";